import React, { Component } from "react";
import { Container, Button, Modal, Form, InputGroup } from "react-bootstrap";
import Select from 'react-select';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
const components = { DropdownIndicator: null };

const createOption = (label) => ({
    label,
    value: label,
});


function cleanValue(val) {
    return (val) ? val.trim() : "";
}


export default class ModalUserDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isWorking: false,
            userScopes: [],
            userScopeErr: "",
            userIdErr: "",
            userNameErr: "",
            userRoleErr: "",
            userPwdErr: "",
            passwordSelectable: true,
            passwordEditable: false,
            passwordType: "password",
            passwordShowLabel: "show",
            selectedLocations: []
        }

        this.initDialog = this.initDialog.bind(this);
        this.onFormValueChange = this.onFormValueChange.bind(this);
        this.onScopeValueChange = this.onScopeValueChange.bind(this);
        this.validate = this.validate.bind(this);
        this.postUser = this.postUser.bind(this);
        this.toScopeValues = this.toScopeValues.bind(this);
        this.userExists = this.userExists.bind(this);
        this.onResetPasswordClick = this.onResetPasswordClick.bind(this);
        this.togglePasswordShow = this.togglePasswordShow.bind(this);

        this.onLocationValueChange = this.onLocationValueChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showNewModal !== this.props.showNewModal) {
            if (this.props.showNewModal) {
                this.initDialog();
            }
        }
    }

    initDialog() {
        // clear out state values
        this.setState({
            userIdErr: "",
            userNameErr: "",
            userRoleErr: "",
            userScopeErr: "",
            userPwdErr: "",
            passwordSelectable: true,
            passwordEditable: false

        });
        if (this.props.editMode === "add") {
            this.setState({
                isWorking: false,
                userId: "",
                userName: "",
                userRole: "",
                userPwd: "",
                userPwd2: "",
                userScopes: [],
                selectedLocations: [],
                passwordSelectable: false,
                passwordEditable: true
            });
        }
        else {
            // update. Set the values
            var existingLocations = [];
            if (Array.isArray(this.props.currentUser.allowedLocations) && Array.isArray(this.props.locationList)) {
                existingLocations = this.props.locationList.filter(
                    loc => this.props.currentUser.allowedLocations.indexOf(loc.id) >= 0
                );
            }
            this.setState(
                {
                    userId: this.props.currentUser.clientId,
                    userName: this.props.currentUser.clientName,
                    userRole: this.props.currentUser.description,
                    userPwd: this.props.currentUser.secret,
                    userPwd2: this.props.currentUser.secret,
                    selectedScopes: Array.isArray(this.props.currentUser.allowedScopes) ? this.toScopeValues() : [],
                    selectedLocations: existingLocations,
                    passwordSelectable: true,
                    passwordEditable: false
                }
            );
        }


    }

    onFormValueChange(e) {
        console.log("Form change: ");
        console.log("id: " + e.target.id);
        console.log("value: " + e.target.value);
        this.setState({ [e.target.id]: e.target.value })
    }


    onScopeValueChange(opts) {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({
            selectedScopes: opts
        })
    }


    onLocationValueChange(opts) {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({
            selectedLocations: opts
        })
    }

    onResetPasswordClick(checked) {
        if (!checked) {
            // reset password values
            this.setState({
                userPwd: this.props.currentUser.secret,
                userPwd2: this.props.currentUser.secret,
            });

        }
        this.setState({ passwordEditable: checked });
    }

    togglePasswordShow() {
        let lbl = this.state.passwordShowLabel;
        if (lbl === "show") {
            this.setState({
                passwordShowLabel: "hide",
                passwordType: "text"
            });
        } else {
            this.setState({
                passwordShowLabel: "show",
                passwordType: "password"
            });
        }
    }

    validate(user) {
        var userIdErr = (user.clientId === "") ? "*You must enter a User Id" : "";
        userIdErr = (user.clientId !== "" && user.clientId.length < 6) ? "* Your id must be at least 6 characters" : userIdErr;
        var userScopeErr = (user.scopes.length < 1) ? "*You must select at least one user right" : "";
        var userNameErr = "";
        var userRoleErr = "";
        var userPwdErr = "";
        if (this.state.passwordEditable) {
            if ((user.password === "") || (this.state.userPwd2 === "")) {
                userPwdErr = "You must enter your password twice.";
            }
            else if (user.password !== this.state.userPwd2) {
                userPwdErr = "Please make sure your password entries match.";
            }
            else if (user.password.includes("**")) {
                userPwdErr = "To change the password, enter actual values in the password fields";
            }
            else if (user.password.length < 6) {
                userPwdErr = "Your password must be at least 6 characters";
            }
        }

        if (this.props.editMode === "add" && this.userExists(user.clientId)) {
            userIdErr = "A User with Id " + user.clientId + " already exists!";
        }

        this.setState(
            {
                userIdErr: userIdErr,
                userNameErr: userNameErr,
                userRoleErr: userRoleErr,
                userScopeErr: userScopeErr,
                userPwdErr: userPwdErr
            }
        )

        return ((userIdErr === "") && (userNameErr === "") && (userRoleErr === "")
            && (userScopeErr === "") && (userPwdErr === ""));
    }



    async postUser() {
        this.setState({ isWorking: true });
        // validate
        var gcid = (this.props.userSession) ? this.props.userSession.gcid : "";
        var name = cleanValue(this.state.userName);
        var role = cleanValue(this.state.userRole);
        //if Array.isArray(this.props.currentUser.allowedScopes)
        var user = {
            "clientId": (this.props.editMode === "add") ? this.state.userId : this.props.currentUser.clientId, // new
            "gcid": gcid,
            "clientName": this.state.userName,
            "role": cleanValue(this.state.userRole),
            "password": (this.state.passwordEditable) ? this.state.userPwd : "", // empty the password so api knows we don't want it changed.
            "scopes": (Array.isArray(this.state.selectedScopes) ? this.state.selectedScopes.map(d => d.value) : []),
            "locations": (Array.isArray(this.state.selectedLocations) ? this.state.selectedLocations.map(d => d.id) : []),
        };
        if (!this.validate(user)) {
            this.setState({ isWorking: false });
            return;
        }

        var postResult = (this.props.editMode === "add") ?
            await this.props.postNew(user)
            : await this.props.postUpdated(user);

        this.setState({ isWorking: false });
    }

    toScopeValues() {
        var filtered = this.props.scopes.filter(nd => this.props.currentUser.allowedScopes.indexOf(nd.value) >= 0);
        return filtered.map(d => {
            return d
        }
        );
    }


    userExists(userId) {
        var lUserId = userId.toLowerCase();
        for (var i = 0; i < this.props.gridData.length; i++) {
            if (this.props.gridData[i].clientId.toLowerCase() === lUserId) {
                return true;
            }
        }
        return false;
    }

    render() {


        const workingButtonIcon = this.state.isWorking ? (
            <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        ) : (
            "Ok"
        );

        const passwordCheckbox = (this.state.passwordSelectable) ?
            <Form.Check type="checkbox" label="Reset Password" onClick={e => this.onResetPasswordClick(e.target.checked)} /> : <span />;

        const showIcon = (this.state.passwordShowLabel === "show") ? "eye" : "eye-slash";

        const showPasswordButton = (this.state.passwordEditable) ?
            <Button
                variant="outline-secondary"
                onClick={this.togglePasswordShow}>
                <FontAwesomeIcon icon={showIcon} />
            </Button> : <span />;


        return (
            <Modal
                show={this.props.showNewModal}
                onHide={this.props.closeNewModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>User Entry/Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    user id&nbsp;<span style={{ color: "red" }} >{this.state.userIdErr}</span>
                                </Form.Text>
                                <Form.Control id="userId" type="text" placeholder="Id" value={this.state.userId} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    name
                                </Form.Text>
                                <Form.Control id="userName" type="text" placeholder="Name" value={this.state.userName} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    role
                                </Form.Text>
                                <Form.Control id="userRole" type="text" placeholder="Role" value={this.state.userRole} onChange={(e) => this.onFormValueChange(e)} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    allowed rights&nbsp;<span style={{ color: "red" }}>{this.state.userScopeErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select allowed rights"}
                                    options={this.props.scopes}
                                    onChange={opts => this.onScopeValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedScopes}
                                />
                            </Form.Group>
                            
                            {/* multiselect still not working? */}
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    allowed locations&nbsp;<span style={{ color: "red" }}>{this.state.userScopeErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select allowed locations"}
                                    options={this.props.locationList}
                                    onChange={opts => this.onLocationValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedLocations}
                                />
                            </Form.Group>


                            <Form.Group className="mb-3">
                                {passwordCheckbox}
                                <Form.Text className="text-muted">
                                    password&nbsp;<span style={{ color: "red" }} >{this.state.userPwdErr}</span>
                                </Form.Text>
                                <span style={{ display: "flex", flexDirection: "row" }}>
                                    <Form.Control
                                        type={this.state.passwordType} autoComplete="off"
                                        readOnly={!this.state.passwordEditable} id="userPwd"
                                        placeholder="Password"
                                        value={this.state.userPwd}
                                        onChange={(e) => this.onFormValueChange(e)}
                                    />
                                    {showPasswordButton}
                                </span>

                                <Form.Text className="text-muted">
                                    re-enter password&nbsp;
                                </Form.Text>
                                <Form.Control
                                    type={this.state.passwordType}
                                    autoComplete="off" readOnly={!this.state.passwordEditable}
                                    id="userPwd2"
                                    placeholder="Password"
                                    value={this.state.userPwd2}
                                    onChange={(e) => this.onFormValueChange(e)}
                                />
                            </Form.Group>

                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={(e) => this.postUser(e)}
                    >
                        {workingButtonIcon}
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={this.props.closeNewModal}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
